import {AppUrls} from 'shared/config/model/urls';

import {MouseEvent, useState} from 'react';
import {generatePath, useNavigate} from 'react-router-dom';

import {getServerDateFormat} from 'features/server/lib/serverView';
import {isTranslate} from 'shared/lib/lang';

import IServerIncident from './ServerIncident/IServerIncident';
import {useServerIncidentSummary} from './useServerIncidentSummary';

export interface IUseServerIncidentRow {
    isOpen: boolean,
    metricLabel: string,
    durationSeconds: number,
    serverName: string,
    dateFormat: string,
    isModalOpen: boolean,
    openModal: () => void,
    closeModal: () => void,
    onButtonClick: (_event: MouseEvent<HTMLTableCellElement>) => void,
}

export const useServerIncidentRow = (
    item: IServerIncident,
    hideServer: boolean,
): IUseServerIncidentRow => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    const {
        isOpen, metricLabel, serverUuid, serverName, durationSeconds,
    } = useServerIncidentSummary(item);

    const onButtonClick = (event: MouseEvent<HTMLTableCellElement>) => {
        event.stopPropagation();
        event.preventDefault();
        if (hideServer) {
            setIsModalOpen(true);
        } else {
            navigate(generatePath(AppUrls.SERVER_DETAILS, {serverId: serverUuid}));
        }
    };

    return {
        isOpen,
        metricLabel,
        durationSeconds,
        serverName,
        dateFormat: getServerDateFormat(isTranslate()),
        isModalOpen,
        openModal: () => setIsModalOpen(true),
        closeModal: () => setIsModalOpen(false),
        onButtonClick,
    };
};

export default useServerIncidentRow;
